import { render, staticRenderFns } from "./SourceDetailModal.vue?vue&type=template&id=4e464437"
import script from "./SourceDetailModal.vue?vue&type=script&lang=js"
export * from "./SourceDetailModal.vue?vue&type=script&lang=js"
import style0 from "./SourceDetailModal.vue?vue&type=style&index=0&id=4e464437&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports